import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { ToBeApprovedDocumentsView } from "@containers/ToBeApprovedDocuments/ToBeApprovedDocumentsView";

const ToBeApprovedSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="tobeApprovedDocuments">
            <ToBeApprovedDocumentsView />
        </AuthenticatedLayout>
    );
}

export default ToBeApprovedSessionsPage;